// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__3ZwJP","topBottomGutter":"Layout_topBottomGutter__piq8P"};